import ahaslides from '@/assets/images/home/ahaslides.png'
import facebookIcon from '@/assets/images/home/facebook.png'
import instagramIcon from '@/assets/images/home/instagram.png'
import linkedInIcon from '@/assets/images/home/linkedin.png'
import youtubeIcon from '@/assets/images/home/youtube.png'

export const socialMediaList = [
  {
    name: 'YouTube',
    imgSrc: youtubeIcon,
    url: 'https://www.youtube.com/channel/UC6ZZtv3C9bveCE8E8tBPhPA',
  },
  {
    name: 'Instagram',
    imgSrc: instagramIcon,
    url: 'https://www.instagram.com/ahaslides/',
  },
  {
    name: 'LinkedIn',
    imgSrc: linkedInIcon,
    url: 'https://www.linkedin.com/company/ahaslides/',
  },
  {
    name: 'AhaSlides Community',
    imgSrc: ahaslides,
    url: 'https://help.ahaslides.com/portal/en/community/ahaslides',
  },
  {
    name: 'Facebook Group',
    imgSrc: facebookIcon,
    url: 'https://www.facebook.com/groups/AhaSlides/',
  },
  {
    name: 'Facebook Page',
    imgSrc: facebookIcon,
    url: 'https://www.facebook.com/AhaSlides/',
  },
]
